<template>
    <customModal :containerxl="true" @closeModal="$emit('closeModal')">

        <template #title>
            CTQ Details
        </template>

        <template #body>
            <div class="modal-content-wrapper">

                <!-- BASIC DETAILS -->
                <div class="section-block">
                    <h6 class="border-bottom mb-0">Basic Information</h6>
                    <div class="row">
                        <div class="col-md-7">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>CTQ ID</strong></div>
                                <div>{{ data.ctqid }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Category</strong></div>
                                <div>{{ data.category }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>CTQ Factor</strong></div>
                                <div>{{ data.ctqFactor }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Domain</strong></div>
                                <div>{{ data.domain }}</div>
                            </div>
                        </div>

                        <div class="col-md-5">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Priority</strong></div>
                                <div>{{ data.priority }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Status</strong></div>
                                <div>{{ data.isActive ? "Active" : "Inactive" }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Study Ref</strong></div>
                                <div>{{ data.studyRef }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block"><strong>Approval Status</strong></div>
                                <div>{{ data.approvals?.[0]?.status || data.approvalStatus  }}</div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- DESCRIPTION -->
                <div class="section-block mt-3">
                    <h6 class="py-1">Description</h6>
                    <div class="border rounded p-3 bg-light">
                        {{ data.ctqDescription  }}
                    </div>
                </div>

                <!-- MEASUREMENT -->
                <div class="section-block mt-3">
                    <h6 class="py-1">Measurement</h6>
                    <div class="border rounded p-3 bg-light">
                        {{ data.measurement  }}
                    </div>
                </div>

                <!-- IMPACT IF MISSING -->
                <div class="section-block mt-3">
                    <h6 class="py-1">Impact if Missing</h6>
                    <div class="border rounded p-3 bg-light">
                        {{ data.impactIfMissing  }}
                    </div>
                </div>

                <!-- CRITICAL DATA POINTS -->
                <div class="section-block mt-3" v-if="data.criticalDataPoints && data.criticalDataPoints.length">
                    <h6 class="py-1">Critical Data Points</h6>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead class="table-light">
                                <tr>
                                    <th>eCRF Form</th>
                                    <th>Field Names</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in data.criticalDataPoints" :key="index">
                                    <td>{{ item.formId }}</td>
                                    <td>{{ Array.isArray(item.fieldnames) ? item.fieldnames.join(", ") : item.fieldnames }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- CRITICAL PROCESSES -->
                <div class="section-block mt-3" v-if="data.criticalProcesses && data.criticalProcesses.length">
                    <h6 class="py-1">Critical Processes</h6>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead class="table-light">
                                <tr>
                                    <th>Process</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in data.criticalProcesses" :key="index">
                                    <td>{{ item }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- QTLs -->
                <div class="section-block mt-3" v-if="data.qtLs && data.qtLs.length">
                    <h6 class="py-1">Quality Tolerance Limits (QTLs)</h6>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead class="table-light">
                                <tr>
                                    <th>QTL</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in data.qtLs" :key="index">
                                    <td>{{ item }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- RISKS -->
                <div class="section-block mt-3" v-if="data.risks && data.risks.length">
                    <h6 class="py-1">Risks</h6>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead class="table-light">
                                <tr>
                                    <th>Risk</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in data.risks" :key="index">
                                    <td>{{ item }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- REVIEW PLAN -->
                <!-- <div class="section-block mt-3" v-if="data.reviewPlan">
                    <h6 class="py-1">Review Plan</h6>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="d-flex border-bottom py-2">
                                <div class="label-block"><strong>Frequency</strong></div>
                                <div>{{ data.reviewPlan.reviewFrequency }}</div>
                            </div>
                            <div class="d-flex py-2">
                                <div class="label-block"><strong>Owner</strong></div>
                                <div>{{ data.reviewPlan.reviewOwner  }}</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex py-2">
                                <div class="label-block"><strong>Method</strong></div>
                                <div>{{ data.reviewPlan.reviewMethod  }}</div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- APPROVALS -->
                <div class="section-block mt-3" v-if="data.approvals && data.approvals.length">
                    <h6 class="py-1">Approval History</h6>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead class="table-light">
                                <tr>
                                    <th>Status</th>
                                    <th>Approved By</th>
                                    <th>Approved Date</th>
                                    <th>Comments</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(approval, index) in data.approvals" :key="index">
                                    <td>{{ approval.status }}</td>
                                    <td>{{ approval.approvedByEmail }}</td>
                                    <td>{{ approval.approvedDate ? $filters?.formatDate(approval.approvedDate) : "—" }}</td>
                                    <td>{{ approval.comments  }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </template>

    </customModal>
</template>

<script>
import customModal from "../customModal/customModal.vue";

export default {
    name: "viewCtqRegistryModal",

    components: { customModal },

    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.section-block h6 {
    font-size: .9rem !important;
    font-weight: 600 !important;
    margin-bottom: 4px;
    color: #3d4b63;
}

.label-block {
    min-width: 120px;
}

.table td,
.table th {
    vertical-align: middle;
}

.modal-content-wrapper {
    max-height: 75vh;
    overflow-y: auto;
    padding-right: 4px;
}
</style>